import React from 'react';
import { Config } from '@leverege/plugin';
import { DateTimePickerV2 } from '@leverege/ui-elements';
import PopupEditorWrapper from "./PopupEditorWrapper.js";
import EditorUtil from "./EditorUtil.js";
import { jsx as _jsx } from "react/jsx-runtime";
const opts = {
  table: {
    embed: true,
    isRenderer: true,
    blockChildren: false
  },
  detail: {
    embed: true,
    isRenderer: true,
    blockChildren: false
  }
};
export default {
  valueType: 'timestamp',
  getOptions: usage => {
    return Config.get('AttributeTimestampEditor', usage, opts[usage]);
  },
  create: opts => {
    const {
      usage,
      context,
      attribute,
      value,
      children,
      ...options
    } = opts;

    // Backwards compatibility.
    const hint = attribute?.blueprint?.attribute?.getTagStartingWith('hint:', true);
    const editorOpts = attribute?.blueprint?.attribute?.metadata?.editorOpts;
    return /*#__PURE__*/_jsx(PopupEditorWrapper, {
      ...options,
      ...editorOpts,
      variant: EditorUtil.getVariant(usage, 'timestamp', 'editor'),
      placeholder: hint,
      value: value,
      usage: usage,
      Editor: DateTimePickerV2,
      children: children
    });
  }
};